<template>
  <j-card
    :title="formTitle"
    class="my-4"
  >
    <j-card-text>
      <j-form
        model="wiki.wikiPage"
      >
        <!-- Title -->
        <j-control name="title" />

        <!-- Body -->
        <j-control
          name="body"
          rows="20"
        />

        <!-- Help -->
        <v-col>
          <a
            href="help"
            @click.prevent="handleShowHelp"
          >Formatting Help</a>
        </v-col>

        <!-- Status -->
        <j-control
          name="status"
          :show-blank="false"
        />

        <!-- Owners -->
        <j-control
          v-if="updatingOwnersAllowed"
          name="owners"
        />

        <!-- Help Modal -->
        <WikiHelp />

      </j-form>
    </j-card-text>
  </j-card>
</template>

<script>

// Components
import WikiHelp from '@/components/panels/wiki/WikiHelp'

// Vuex
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters } = createNamespacedHelpers('wiki')

export default {
  name: 'WikiPageForm',
  components: {
    WikiHelp
  },
  computed: {
    ...mapState([
      'wikiPage'
    ]),
    ...mapGetters([
      'allowEdits'
    ]),
    formTitle () {
      return this.wikiPage.isNew() ? 'Create a wiki page here...' : 'Edit Wiki Page'
    },
    updatingOwnersAllowed () {
      const assignedOwners = (this.wikiPage.owners.length > 0)
      return (assignedOwners && this.allowEdits) || this.$store.getters['currentUser/isAdmin']
    }
  },
  methods: {
    handleShowHelp() {
      this.$dialog.open('wiki-help')
    }
  }
}
</script>
